
export type additionalOptionsT = {
    search?: string
    [key: string]: any
}

type responseData = {
    count: number
    next: string
    previous: string | null
    results: any[]
}
type optionT = {

    label: string,
}

export const LoadingInvoiceData = (getOptions: any) => async (_: any, loadedOptions: any, ...props: additionalOptionsT[]) => {

    const { search} = props[0];

    const response: any = await getOptions({  search });

    const dataResponse: responseData = response.data;

    const options: optionT[] = dataResponse.results.map((item: any) => {
        const label: string = `${item.email}`
        const salesforce_id = `${item.salesforce_id}`
        return { label, salesforce_id };
    });
    return {
        options: options,
        hasMore: !!dataResponse.next,
        additional: {
            search: search,

        },
    };
}